import { Component } from 'react'
import { Box, Icons, KeyValueRow } from 'stylewhere/components'
import { T, __ } from 'stylewhere/shared/i18n'
import { EncodingCounters } from 'stylewhere/api'
import { getEncodedOrder, getEncodedOrderRow, getExpectedOrder, getExpectedRow } from 'stylewhere/utils'

export interface EncodingCountersBoxProps {
  counters?: EncodingCounters
  productionOrderDetail?: () => void
}

export class EncodingCountersBox extends Component<EncodingCountersBoxProps> {
  render() {
    const { counters, productionOrderDetail } = this.props
    const encodedOrder = getEncodedOrder(counters)
    const expectedOrder = getExpectedOrder(counters)
    const encodedOrderRow = getEncodedOrderRow(counters)
    const expectedOrderRow = counters.row ? getExpectedRow(counters) : 0
    return (
      <KeyValueRow style={{ margin: 2 }}>
        <KeyValueRow
          variant="raw"
          value={expectedOrder > 0 ? `${encodedOrder} / ${expectedOrder}` : `${encodedOrder}`}
          label={__(T.misc.item_order)}
          onClick={productionOrderDetail}
          image={productionOrderDetail ? <Icons.Info width={22} height={22} /> : undefined}
        />
        {counters.row && (
          <>
            <Box height={60} width={2} bgGrey />
            <KeyValueRow
              variant="raw"
              value={expectedOrderRow > 0 ? `${encodedOrderRow} / ${expectedOrderRow}` : `${encodedOrderRow}`}
              label={__(T.misc.item_row)}
            />
          </>
        )}
      </KeyValueRow>
    )
  }
}
